import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: translations.en,
});

const STORAGE_KEY = "mise_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY);
      return saved === "fr" ? "fr" : "en";
    } catch {
      return "en";
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.lang = lang;
    } catch {
      // ignore
    }
  }, [lang]);

  const setLang = (next) => {
    if (next === "en" || next === "fr") setLangState(next);
  };

  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang] || translations.en }),
    [lang],
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
